class GlobalUtil {
    removeWindow() {
        for(let countWindow = 0; countWindow < 4; countWindow++) {
            // delete window
            let window = document.querySelector('body').getElementsByClassName('panel f-column window window-shadow');
            for(let i = 0; i < window.length; i++) {
                window[i].remove();
            }

            // delete windowMask
            let windowMask = document.querySelector('body').getElementsByClassName('window-mask');
            for(let i = 0; i < windowMask.length; i++) {
                windowMask[i].remove();
            }
        }
    }

    formatPhone(phone) {
        if (!phone) return "";

        // Hapus semua karakter selain angka
        phone = phone.replace(/\D/g, "");

        // +62xxxxx → 0xxxxx
        if (phone.startsWith("62")) {
            phone = "0" + phone.substring(2);
        }

        return phone;
    }

    base64UrlEncode(value) {
        return btoa(value)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    base64UrlDecode(value) {
        value = value
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        while (value.length % 4) value += '=';

        return atob(value);
    }
}

export default new GlobalUtil();